export const feedback = {
  title: "Quejas y Sugerencias",
  subtitle: "Protocolo de Recogida y Gestión de Quejas de las Familias",
  protocol: {
    title: "Protocolo de Gestión de la Comunicación y Quejas de las Familias",
    purpose: {
      title: "Propósito y Filosofía",
      points: [
        "Establecer un canal claro, organizado y eficaz para que las familias puedan expresar sus preocupaciones, sugerencias o quejas.",
        "Garantizar que todas las comunicaciones sean escuchadas y tratadas con la debida atención y respeto.",
        "Proteger y apoyar al equipo de acompañantes, actuando como filtro y facilitador en la gestión de las quejas.",
        "Fomentar un ambiente de confianza, respeto y mejora continua en la comunidad educativa."
      ]
    },
    scope: {
      title: "Aplicación",
      description: "Este protocolo aplica a todas las comunicaciones formales de queja o preocupación presentadas por las familias de los alumnos y alumnas de la escuela. También es válido para recoger propuestas de mejora."
    }
  },
  contact: {
    title: "Canal Único de Recepción",
    email: {
      title: "Comunicación por Email",
      description: "Todas las quejas o preocupaciones de las familias deberán ser dirigidas exclusivamente al Director."
    },
    appointment: {
      title: "Cita Previa con Dirección",
      description: "Para aquellos casos que requieran una conversación presencial, serán atendidos siempre con cita previa concertada a través de email.",
      note: "Se informará a las familias sobre este protocolo y el canal único para asegurar su correcto uso."
    }
  },
  process: {
    title: "Proceso de Gestión de la Queja",
    phases: [
      {
        title: "Fase 1: Recepción y Filtro Inicial por Dirección",
        description: "El Director recibe la queja por el canal establecido y realiza un análisis inicial.",
        steps: [
          "En un plazo máximo de 48 horas hábiles, se enviará un acuse de recibo a la familia.",
          "El Director realizará una lectura y análisis detallado de la queja.",
          "Se evaluará la claridad, relevancia, gravedad/urgencia, competencia y contexto.",
          "Objetivo del filtro: Proteger al equipo de quejas infundadas y priorizar las importantes."
        ]
      },
      {
        title: "Fase 2: Decisión y Derivación por Dirección",
        description: "Basado en el análisis inicial, el Director decidirá la acción a seguir:",
        steps: [
          "Resolución Directa por Dirección: Para quejas menores o malentendidos simples.",
          "Derivación al Equipo (Filtrada y Gestionada): Para quejas que requieren intervención del personal.",
          "Investigación o reunión con ambas partes: Para quejas graves o complejas.",
          "Queja No Procesable: Si la queja es infundada o cae fuera de competencia."
        ]
      },
      {
        title: "Fase 3: Seguimiento y Cierre",
        description: "El Director supervisa la evolución y comunica la resolución a la familia.",
        steps: [
          "Coordinación y seguimiento interno de las acciones acordadas.",
          "Comunicación a la familia de la resolución o medidas adoptadas.",
          "Se buscará un cierre satisfactorio para todas las partes cuando sea posible."
        ]
      }
    ]
  },
  guarantees: {
    title: "Confidencialidad y Respeto",
    points: [
      "Toda la información relacionada con las quejas será tratada con la máxima confidencialidad.",
      "Se promoverá un ambiente respetuoso en todas las comunicaciones.",
      "Se mantendrá un registro interno para identificar patrones y áreas de mejora.",
      "Este protocolo será revisado anualmente para asegurar su efectividad."
    ]
  }
};